import axios from '../axios'

// フィードバック返信（担当講師・1回）
const postFeedbackReplyApi = async (feedbackId, body) => {
  return await axios.post(`api/lms/feedback/${feedbackId}/reply`, { body })
}

export default postFeedbackReplyApi
